/**
 * @generated SignedSource<<339b91cf8081b76122aaed1df9c9c01e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubblesWrapper_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbles_viewer">;
  readonly " $fragmentType": "PdpRespIconBubblesWrapper_viewer";
};
export type PdpRespIconBubblesWrapper_viewer$key = {
  readonly " $data"?: PdpRespIconBubblesWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubblesWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubblesWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbles_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2536db58eb5d34fceb53eb67fb05f47c";

export default node;
